var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
var BarChart = function (_a) {
    var resultsByDay = _a.resultsByDay, fields = _a.fields, _b = _a.height, height = _b === void 0 ? 300 : _b, _c = _a.horizontal, horizontal = _c === void 0 ? false : _c;
    var labels = Object.keys(resultsByDay).map(function (date) {
        return date.split("-").reverse().slice(0, 2).join("/");
    });
    var datasets = fields.map(function (field) { return ({
        type: field.type,
        label: field.label,
        data: Object.values(resultsByDay).map(function (d) { var _a; return (_a = d[field.key]) !== null && _a !== void 0 ? _a : 0; }),
        backgroundColor: field.type === "bar" ? field.color : "transparent", // barras coloridas, linha transparente
        borderColor: field.type === "line" ? field.color : undefined, // linha colorida
        borderWidth: field.type === "line" ? 2 : undefined,
        fill: false,
        yAxisID: field.yAxisID,
        pointRadius: field.type === "line" ? 0 : undefined, // <-- Adicione esta linha
    }); });
    // Só mostra y1 se houver mais de um campo
    var showY1 = fields.length > 1;
    return (React.createElement("div", { style: { height: height, width: "100%" } },
        React.createElement(Bar, { data: { labels: labels, datasets: datasets }, options: {
                indexAxis: horizontal ? "y" : "x", // <-- define orientação
                plugins: {
                    legend: { labels: { color: "#fff" } },
                    datalabels: {
                        color: "#fff",
                        font: { weight: "bold" },
                    },
                },
                maintainAspectRatio: false,
                responsive: true,
                scales: __assign({ x: { ticks: { color: "#fff" } }, y: { ticks: { color: "#fff" } } }, (showY1 && {
                    y1: {
                        position: "right",
                        grid: { drawOnChartArea: false },
                        ticks: { color: "#fde047" },
                    },
                })),
            }, plugins: [ChartDataLabels], height: height })));
};
export default BarChart;
